module.exports = __webpack_public_path__ + "img/75600.1be916a9.jpg";